var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReadNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.198,
    height: 24.3,
    viewBox: "0 0 24.198 24.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-4165.85 -3770.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_395286296",
    transform: "translate(4166 3771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M4187.515,3793.979h-19.132c.068-.034.034-.034.1-.1l9.43-5.583c.238-.034,7.966,4.663,8.953,5.276Zm1.4-12.324V3793.6c-.477-.239-.817-.477-1.26-.749l-3.711-2.247c-.2-.1-4.765-2.928-5-3Zm-21.923,11.881v-11.949c.953.51,4.017,2.417,4.969,3l4.7,2.792c.2.1.169,0,.237.238a5.655,5.655,0,0,0-.612.341Zm3.2-11.37v-9.533a.537.537,0,0,1,.544-.544h14.435a.538.538,0,0,1,.545.544v9.6c0,.17-.579.477-.886.647l-2.927,1.736c-.681.408-1.293.783-1.94,1.157l-1.838,1.089-.136.136c-1.6-1.055-5.039-3.063-6.877-4.153C4170.8,3782.677,4170.188,3782.37,4170.188,3782.166Zm16.544-.511v-1.906a15.953,15.953,0,0,0,1.6.885v.136a4.5,4.5,0,0,0-.782.443C4187.243,3781.383,4187.039,3781.519,4186.732,3781.655Zm-19.166-1.021a2.606,2.606,0,0,0,.817-.409c.272-.136.511-.272.782-.409v1.839Zm1.6-2.008c-.271.136-.544.272-.817.442l-1.7.953c-.307.17-.647.272-.647.681v13.788c0,.2.17.51.375.51h23.012a.483.483,0,0,0,.511-.51v-13.924c0-.273-1.157-.851-1.5-1.021-.272-.136-.511-.307-.817-.477-.272-.17-.579-.306-.851-.442v-5.992c0-1.191-.885-1.634-1.975-1.634h-13.617c-2.213,0-1.975,1.532-1.975,2.791Z",
    transform: "translate(-4166 -3771)",
    fill: "#030303",
    stroke: "#000",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M4359,3935.443c0,.443.273.646.715.646h9.191c.919,0,.919-1.089,0-1.089h-9.191C4359.273,3935,4359,3935.273,4359,3935.443Z",
    transform: "translate(-4352.43 -3929.417)",
    fill: "#0e0e0e",
    stroke: "#000",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M4359,4082.51a.5.5,0,0,0,.511.511h9.6c.682,0,.545-1.022.068-1.022h-9.667A.5.5,0,0,0,4359,4082.51Z",
    transform: "translate(-4352.43 -4071.412)",
    fill: "#030303",
    stroke: "#000",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M4359,4010.443a.568.568,0,0,0,.579.544h9.6c.443,0,.647-.987-.068-.987h-9.7A.474.474,0,0,0,4359,4010.443Z",
    transform: "translate(-4352.43 -4001.865)",
    fill: "#030303",
    stroke: "#000",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M4359,3860.51c0,.409.307.579.715.579h4.494c.987,0,.817-1.09.135-1.09h-4.766A.62.62,0,0,0,4359,3860.51Z",
    transform: "translate(-4352.43 -3856.97)",
    fill: "#0e0e0e",
    stroke: "#000",
    strokeWidth: 0.3,
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadNotification);
export default __webpack_public_path__ + "static/media/readNotification.6c5918f14727c0f841c9f824650b76c7.svg";
export { ForwardRef as ReactComponent };